'use strict';

/**
 * GeoJsonRenderer
 *
 * This is essentially just a placeholder for the time being. Currently is takes
 * a transformed dataset and formats it so that that it can be passed to the
 * geojson attribute set up by the Angular-Leaflet directive
 *
 * In the future it will serve to do the actual rendering
 *
 * TODO merge with MarkerCluster Renderer
 */

var _ = require('lodash');
var Renderer = require('./Renderer');

var GeoJsonRenderer = Renderer.extend({

  constructor: function (options) {
    Renderer.call(this, options);
  },

  render: function (dataset, options) {
    var transformer = this.transformer;

    return _.reduce(transformer.parse(dataset, options), function (layers, layer, layerId) {
      layers[layerId] = {
        data: layer.data,
        options: {
          onEachFeature: layer.onEachFeature,
          pointToLayer: layer.pointToLayer,
          style: layer.style
        }
      };

      return layers;
    }, {});
  }
})

module.exports = GeoJsonRenderer;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/render/GeoJsonRenderer.js